﻿﻿export interface IProductStatus {
    id: number;
    description: string;
    prospectStatusId: number;
    prospectStatusDescription: string;
    color: string;
    textColor: string;
    isInUse: boolean;
}
